import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { CourseCard } from '@lib/interfaces';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AllCoursesService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = environment.API_URL;

    getPopularCourses(
        page: number = 1,
        size: number = 10,
        isParent: boolean = false,
        filters?: {
            searchParam?: string;
            topicIds?: string;
            courseTypeIds?: string;
        },
    ): Observable<{ data: CourseCard[]; hasNext: boolean }> {
        let params = new HttpParams().set('page', page).set('size', size).set('isParent', isParent);

        // Add filter parameters if provided
        if (filters?.searchParam) {
            params = params.set('searchParam', filters.searchParam);
        }
        if (filters?.topicIds) {
            params = params.set('topicId', filters.topicIds);
        }
        if (filters?.courseTypeIds) {
            params = params.set('courseTypeId', filters.courseTypeIds);
        }

        return this.http.get<{ data: CourseCard[]; hasNext: boolean }>(`${this.baseUrl}/students/course/popular`, {
            params,
        });
    }
}
